import { Component, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MenuItem, MenuService } from 'app/shared/service/menu.service';
import { environment } from 'environments/environment.prod';
@Component({
  selector: 'app-sidebar',
  imports: [RouterModule, MatIconModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  standalone: true,
})
export class SidebarComponent implements OnInit {
  menuItems: MenuItem[] = [];
  private menuService = inject(MenuService);

  ngOnInit(): void {
    this.menuItems = this.menuService.getMenuItems();
  }
  redirectSite() {
    window.open(environment.host);
  }
}
